// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file job.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AiVerification, AiVerificationJson } from "./ai_verification_pb";
import { file_ai_verification } from "./ai_verification_pb";
import type { ContainerGroup, ContainerGroupJson, ContainerType, ContainerTypeJson } from "./container_group_pb";
import { file_container_group } from "./container_group_pb";
import type { Contract, ContractJson } from "./contract_pb";
import { file_contract } from "./contract_pb";
import type { DriverOnShift, DriverOnShiftJson } from "./driver_on_shift_pb";
import { file_driver_on_shift } from "./driver_on_shift_pb";
import type { DispatcherReviewStatus, DispatcherReviewStatusJson, JobCategory, JobCategoryJson, JobEvent, JobEventJson, JobStatus, JobStatusJson, JobType, JobTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { File, FileJson, FileUpload, FileUploadJson, FileUploadType, FileUploadTypeJson } from "./file_upload_pb";
import { file_file_upload } from "./file_upload_pb";
import type { ListInfo, ListInfoJson, UserRef, UserRefJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Organization, OrganizationJson } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { PickupLocation, PickupLocationJson } from "./pickup_location_pb";
import { file_pickup_location } from "./pickup_location_pb";
import type { User, UserJson } from "./user_pb";
import { file_user } from "./user_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file job.proto.
 */
export const file_job: GenFile = /*@__PURE__*/
  fileDesc("Cglqb2IucHJvdG8SCXJhY2Nvb25haSJyCgpKb2JFdmVudEluEiIKBWV2ZW50GAEgAigOMhMucmFjY29vbmFpLkpvYkV2ZW50EhYKBmpvYl9pZBgCIAIoBFIGam9iX2lkEigKB3BheWxvYWQYAyABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0IpIXCgNKb2ISCgoCaWQYASACKAQSOgoKY3JlYXRlZF9hdBgCIAIoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSCmNyZWF0ZWRfYXQSMAoTc2VydmljZV9wcm92aWRlcl9pZBgDIAIoBFITc2VydmljZV9wcm92aWRlcl9pZBIwChNzZXJ2aWNlX3JlY2VpdmVyX2lkGAQgAigEUhNzZXJ2aWNlX3JlY2VpdmVyX2lkEjwKC3R3X3N0YXJ0X2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFILdHdfc3RhcnRfYXQSOAoJdHdfZW5kX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIJdHdfZW5kX2F0EhoKCHN0ZXBfaWR4GAcgASgEUghzdGVwX2lkeBIcCglhdXRob3JfaWQYCCACKARSCWF1dGhvcl9pZBIuChJkcml2ZXJfb25fc2hpZnRfaWQYCSABKARSEmRyaXZlcl9vbl9zaGlmdF9pZBIuChJwaWNrdXBfbG9jYXRpb25faWQYCiACKARSEnBpY2t1cF9sb2NhdGlvbl9pZBI+ChpzZXJ2aWNlX3N0YXJ0ZWRfcmVwb3J0X3VybBgLIAEoCVIac2VydmljZV9zdGFydGVkX3JlcG9ydF91cmwSOgoYc2VydmljZV9lbmRlZF9yZXBvcnRfdXJsGAwgASgJUhhzZXJ2aWNlX2VuZGVkX3JlcG9ydF91cmwSGgoIcm91dGVfaWQYDSABKARSCHJvdXRlX2lkEiYKDmRyaXZlcl9jb21tZW50GA4gASgJUg5kcml2ZXJfY29tbWVudBJACg1wbGFuX3N0YXJ0X2F0GBAgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFINcGxhbl9zdGFydF9hdBI8CgtwbGFuX2VuZF9hdBgRIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSC3BsYW5fZW5kX2F0EkAKDWZhY3Rfc3RhcnRfYXQYEiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUg1mYWN0X3N0YXJ0X2F0EjwKC2ZhY3RfZW5kX2F0GBMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFILZmFjdF9lbmRfYXQSJAoGc3RhdHVzGBQgAigOMhQucmFjY29vbmFpLkpvYlN0YXR1cxJDChBzZXJ2aWNlX3JlY2VpdmVyGBUgASgLMhcucmFjY29vbmFpLk9yZ2FuaXphdGlvblIQc2VydmljZV9yZWNlaXZlchJDCg9waWNrdXBfbG9jYXRpb24YFiABKAsyGS5yYWNjb29uYWkuUGlja3VwTG9jYXRpb25SD3BpY2t1cF9sb2NhdGlvbhJCCg9kcml2ZXJfb25fc2hpZnQYFyABKAsyGC5yYWNjb29uYWkuRHJpdmVyT25TaGlmdFIPZHJpdmVyX29uX3NoaWZ0EiAKBHR5cGUYGCACKA4yEi5yYWNjb29uYWkuSm9iVHlwZRJdChhkaXNwYXRjaGVyX3Jldmlld19zdGF0dXMYGSACKA4yIS5yYWNjb29uYWkuRGlzcGF0Y2hlclJldmlld1N0YXR1c1IYZGlzcGF0Y2hlcl9yZXZpZXdfc3RhdHVzEjgKF3NlcnZpY2Vfc3RhcnRfcGhvdG9fbGF0GBogASgBUhdzZXJ2aWNlX3N0YXJ0X3Bob3RvX2xhdBI4ChdzZXJ2aWNlX3N0YXJ0X3Bob3RvX2xvbhgbIAEoAVIXc2VydmljZV9zdGFydF9waG90b19sb24SNAoVc2VydmljZV9lbmRfcGhvdG9fbGF0GBwgASgBUhVzZXJ2aWNlX2VuZF9waG90b19sYXQSNAoVc2VydmljZV9lbmRfcGhvdG9fbG9uGB0gASgBUhVzZXJ2aWNlX2VuZF9waG90b19sb24SJgoOY29udGFpbmVyX25hbWUYHiABKAlSDmNvbnRhaW5lcl9uYW1lEh4KCmpvYl90YXJpZmYYHyABKARSCmpvYl90YXJpZmYSHAoJaXNfcHNldWRvGCAgASgIUglpc19wc2V1ZG8SPgoMZ3BzX3N0YXJ0X2F0GCEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIMZ3BzX3N0YXJ0X2F0EjoKCmdwc19lbmRfYXQYIiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgpncHNfZW5kX2F0EjIKFGlzX2NyZWF0ZWRfYnlfY2xpZW50GCMgASgIUhRpc19jcmVhdGVkX2J5X2NsaWVudBIoCg9zY2FsZV9yZWNvcmRfaWQYJCABKARSD3NjYWxlX3JlY29yZF9pZBIfCgZhdXRob3IYJSABKAsyDy5yYWNjb29uYWkuVXNlchI5CgxmaWxlX3JlcG9ydHMYJiADKAsyFS5yYWNjb29uYWkuRmlsZVVwbG9hZFIMZmlsZV9yZXBvcnRzEiQKDXZpc2libGVfdG9fYWkYJyABKAhSDXZpc2libGVfdG9fYWkSOgoMam9iX2NhdGVnb3J5GCggAigOMhYucmFjY29vbmFpLkpvYkNhdGVnb3J5Ugxqb2JfY2F0ZWdvcnkSLAoRY29udGFpbmVyX3R5cGVfaWQYKSABKARSEWNvbnRhaW5lcl90eXBlX2lkEkAKDmNvbnRhaW5lcl90eXBlGCogASgLMhgucmFjY29vbmFpLkNvbnRhaW5lclR5cGVSDmNvbnRhaW5lcl90eXBlEiIKDG9yZGVyX251bWJlchgrIAEoCVIMb3JkZXJfbnVtYmVyEiwKEXJlY2VpdmVyX25vdGlmaWVkGCwgASgIUhFyZWNlaXZlcl9ub3RpZmllZBJDCg9jb250YWluZXJfZ3JvdXAYLSABKAsyGS5yYWNjb29uYWkuQ29udGFpbmVyR3JvdXBSD2NvbnRhaW5lcl9ncm91cBI6Cgp1cGRhdGVkX2F0GC4gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIKdXBkYXRlZF9hdBIyCgp1cGRhdGVkX2J5GDcgASgLMhIucmFjY29vbmFpLlVzZXJSZWZSCnVwZGF0ZWRfYnkSQwoQc2VydmljZV9wcm92aWRlchgvIAEoCzIXLnJhY2Nvb25haS5Pcmdhbml6YXRpb25SEHNlcnZpY2VfcHJvdmlkZXISOgoYcGlja3VwX2xvY2F0aW9uX2dyb3VwX2lkGDAgASgEUhhwaWNrdXBfbG9jYXRpb25fZ3JvdXBfaWQSQwoPYWlfdmVyaWZpY2F0aW9uGDEgASgLMhkucmFjY29vbmFpLkFpVmVyaWZpY2F0aW9uUg9haV92ZXJpZmljYXRpb24SLgoSd2hhdHNhcHBfYXV0aG9yX2lkGDIgASgEUhJ3aGF0c2FwcF9hdXRob3JfaWQSKgoQbnVtX29mX2NvbnRhaW5lchgzIAEoAVIQbnVtX29mX2NvbnRhaW5lchIcCgl3ZWlnaHRfa2cYNCABKAFSCXdlaWdodF9rZxI2ChZjb250YWluZXJfY29lZmZpY2llbnRzGDUgAygBUhZjb250YWluZXJfY29lZmZpY2llbnRzEiwKEWZhY3RfdG90YWxfdm9sdW1lGDYgASgBUhFmYWN0X3RvdGFsX3ZvbHVtZRIyChRudW1iZXJfb2ZfY29udGFpbmVycxg4IAEoDVIUbnVtYmVyX29mX2NvbnRhaW5lcnMSIAoLY29udHJhY3RfaWQYOSABKARSC2NvbnRyYWN0X2lkEiAKC3NjaGVkdWxlX2lkGDogASgEUgtzY2hlZHVsZV9pZBIlCghjb250cmFjdBg7IAEoCzITLnJhY2Nvb25haS5Db250cmFjdCLRCAoJSm9iQ3JlYXRlEjAKE3NlcnZpY2VfcHJvdmlkZXJfaWQYASABKARSE3NlcnZpY2VfcHJvdmlkZXJfaWQSMAoTc2VydmljZV9yZWNlaXZlcl9pZBgCIAEoBFITc2VydmljZV9yZWNlaXZlcl9pZBI8Cgt0d19zdGFydF9hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSC3R3X3N0YXJ0X2F0EjgKCXR3X2VuZF9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSCXR3X2VuZF9hdBIaCghzdGVwX2lkeBgFIAEoBFIIc3RlcF9pZHgSHAoJYXV0aG9yX2lkGAYgASgEUglhdXRob3JfaWQSLgoSZHJpdmVyX29uX3NoaWZ0X2lkGAcgASgEUhJkcml2ZXJfb25fc2hpZnRfaWQSLgoScGlja3VwX2xvY2F0aW9uX2lkGAggAigEUhJwaWNrdXBfbG9jYXRpb25faWQSPgoac2VydmljZV9zdGFydGVkX3JlcG9ydF91cmwYCSABKAlSGnNlcnZpY2Vfc3RhcnRlZF9yZXBvcnRfdXJsEjoKGHNlcnZpY2VfZW5kZWRfcmVwb3J0X3VybBgKIAEoCVIYc2VydmljZV9lbmRlZF9yZXBvcnRfdXJsEhoKCHJvdXRlX2lkGAsgASgEUghyb3V0ZV9pZBImCg5kcml2ZXJfY29tbWVudBgMIAEoCVIOZHJpdmVyX2NvbW1lbnQSQAoNcGxhbl9zdGFydF9hdBgNIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSDXBsYW5fc3RhcnRfYXQSPAoLcGxhbl9lbmRfYXQYDiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgtwbGFuX2VuZF9hdBIgCgR0eXBlGA8gAigOMhIucmFjY29vbmFpLkpvYlR5cGUSHgoKam9iX3RhcmlmZhgQIAEoBFIKam9iX3RhcmlmZhIcCglpc19wc2V1ZG8YESABKAhSCWlzX3BzZXVkbxIkCg12aXNpYmxlX3RvX2FpGBIgASgIUg12aXNpYmxlX3RvX2FpEjoKDGpvYl9jYXRlZ29yeRgTIAIoDjIWLnJhY2Nvb25haS5Kb2JDYXRlZ29yeVIMam9iX2NhdGVnb3J5EiwKEWNvbnRhaW5lcl90eXBlX2lkGBQgASgEUhFjb250YWluZXJfdHlwZV9pZBIuChJjb250YWluZXJfZ3JvdXBfaWQYFSABKARSEmNvbnRhaW5lcl9ncm91cF9pZBI6ChhwaWNrdXBfbG9jYXRpb25fZ3JvdXBfaWQYFiABKARSGHBpY2t1cF9sb2NhdGlvbl9ncm91cF9pZBIyChRudW1iZXJfb2ZfY29udGFpbmVycxgXIAEoDVIUbnVtYmVyX29mX2NvbnRhaW5lcnMiug0KCUpvYlVwZGF0ZRIKCgJpZBgBIAIoBBIwChNzZXJ2aWNlX3Byb3ZpZGVyX2lkGAIgASgEUhNzZXJ2aWNlX3Byb3ZpZGVyX2lkEjAKE3NlcnZpY2VfcmVjZWl2ZXJfaWQYAyABKARSE3NlcnZpY2VfcmVjZWl2ZXJfaWQSPAoLdHdfc3RhcnRfYXQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgt0d19zdGFydF9hdBI4Cgl0d19lbmRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgl0d19lbmRfYXQSGgoIc3RlcF9pZHgYBiABKARSCHN0ZXBfaWR4Ei4KEmRyaXZlcl9vbl9zaGlmdF9pZBgHIAEoBFISZHJpdmVyX29uX3NoaWZ0X2lkEi4KEnBpY2t1cF9sb2NhdGlvbl9pZBgIIAEoBFIScGlja3VwX2xvY2F0aW9uX2lkEj4KGnNlcnZpY2Vfc3RhcnRlZF9yZXBvcnRfdXJsGAkgASgJUhpzZXJ2aWNlX3N0YXJ0ZWRfcmVwb3J0X3VybBI6ChhzZXJ2aWNlX2VuZGVkX3JlcG9ydF91cmwYCiABKAlSGHNlcnZpY2VfZW5kZWRfcmVwb3J0X3VybBIaCghyb3V0ZV9pZBgLIAEoBFIIcm91dGVfaWQSJgoOZHJpdmVyX2NvbW1lbnQYDCABKAlSDmRyaXZlcl9jb21tZW50EkAKDXBsYW5fc3RhcnRfYXQYDSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUg1wbGFuX3N0YXJ0X2F0EjwKC3BsYW5fZW5kX2F0GA4gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFILcGxhbl9lbmRfYXQSQAoNZmFjdF9zdGFydF9hdBgPIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSDWZhY3Rfc3RhcnRfYXQSPAoLZmFjdF9lbmRfYXQYECABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgtmYWN0X2VuZF9hdBIkCgZzdGF0dXMYESABKA4yFC5yYWNjb29uYWkuSm9iU3RhdHVzEiAKBHR5cGUYEiABKA4yEi5yYWNjb29uYWkuSm9iVHlwZRJdChhkaXNwYXRjaGVyX3Jldmlld19zdGF0dXMYEyABKA4yIS5yYWNjb29uYWkuRGlzcGF0Y2hlclJldmlld1N0YXR1c1IYZGlzcGF0Y2hlcl9yZXZpZXdfc3RhdHVzEjgKF3NlcnZpY2Vfc3RhcnRfcGhvdG9fbGF0GBQgASgBUhdzZXJ2aWNlX3N0YXJ0X3Bob3RvX2xhdBI4ChdzZXJ2aWNlX3N0YXJ0X3Bob3RvX2xvbhgVIAEoAVIXc2VydmljZV9zdGFydF9waG90b19sb24SNAoVc2VydmljZV9lbmRfcGhvdG9fbGF0GBYgASgBUhVzZXJ2aWNlX2VuZF9waG90b19sYXQSNAoVc2VydmljZV9lbmRfcGhvdG9fbG9uGBcgASgBUhVzZXJ2aWNlX2VuZF9waG90b19sb24SJgoOY29udGFpbmVyX25hbWUYGCABKAlSDmNvbnRhaW5lcl9uYW1lEh4KCmpvYl90YXJpZmYYGSABKARSCmpvYl90YXJpZmYSHAoJaXNfcHNldWRvGBogASgIUglpc19wc2V1ZG8SPgoMZ3BzX3N0YXJ0X2F0GBwgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIMZ3BzX3N0YXJ0X2F0EjoKCmdwc19lbmRfYXQYHSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgpncHNfZW5kX2F0EiQKDXZpc2libGVfdG9fYWkYHiABKAhSDXZpc2libGVfdG9fYWkSOgoMam9iX2NhdGVnb3J5GB8gASgOMhYucmFjY29vbmFpLkpvYkNhdGVnb3J5Ugxqb2JfY2F0ZWdvcnkSLAoRY29udGFpbmVyX3R5cGVfaWQYICABKARSEWNvbnRhaW5lcl90eXBlX2lkEiwKEXJlY2VpdmVyX25vdGlmaWVkGCEgASgIUhFyZWNlaXZlcl9ub3RpZmllZBIuChJjb250YWluZXJfZ3JvdXBfaWQYIiABKARSEmNvbnRhaW5lcl9ncm91cF9pZBIyChRudW1iZXJfb2ZfY29udGFpbmVycxgjIAEoDVIUbnVtYmVyX29mX2NvbnRhaW5lcnMiWgoHSm9iTGlzdBIcCgRqb2JzGAEgAygLMg4ucmFjY29vbmFpLkpvYhIxCglsaXN0X2luZm8YAiABKAsyEy5yYWNjb29uYWkuTGlzdEluZm9SCWxpc3RfaW5mbyLWAQoUSm9iRmlsZVVwbG9hZFJlcXVlc3QSHQoEZmlsZRgBIAIoCzIPLnJhY2Nvb25haS5GaWxlEicKBHR5cGUYAiACKA4yGS5yYWNjb29uYWkuRmlsZVVwbG9hZFR5cGUSFgoGam9iX2lkGAMgASgEUgZqb2JfaWQSJgoOY29udGFpbmVyX25hbWUYBCABKAlSDmNvbnRhaW5lcl9uYW1lEjYKFmNvbnRhaW5lcl9jb2VmZmljaWVudHMYBSADKAFSFmNvbnRhaW5lcl9jb2VmZmljaWVudHMilgIKB0pvYlN0b3ASLgoSY29udGFpbmVyX2dyb3VwX2lkGAEgASgEUhJjb250YWluZXJfZ3JvdXBfaWQSLgoIam9iX3R5cGUYAiABKA4yEi5yYWNjb29uYWkuSm9iVHlwZVIIam9iX3R5cGUSFgoGam9iX2lkGAMgASgEUgZqb2JfaWQSPAoLdHdfc3RhcnRfYXQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgt0d19zdGFydF9hdBI4Cgl0d19lbmRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgl0d19lbmRfYXQSGwoDam9iGAYgASgLMg4ucmFjY29vbmFpLkpvYkIGWgQuL3Bi", [file_ai_verification, file_container_group, file_contract, file_driver_on_shift, file_enums, file_file_upload, file_general, file_google_protobuf_struct, file_google_protobuf_timestamp, file_organization, file_pickup_location, file_user]);

/**
 * To be deprecated
 *
 * @generated from message raccoonai.JobEventIn
 */
export type JobEventIn = Message<"raccoonai.JobEventIn"> & {
  /**
   * @generated from field: required raccoonai.JobEvent event = 1;
   */
  event: JobEvent;

  /**
   * @generated from field: required uint64 job_id = 2 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: optional google.protobuf.Struct payload = 3;
   */
  payload?: JsonObject;
};

/**
 * To be deprecated
 *
 * @generated from message raccoonai.JobEventIn
 */
export type JobEventInJson = {
  /**
   * @generated from field: required raccoonai.JobEvent event = 1;
   */
  event?: JobEventJson;

  /**
   * @generated from field: required uint64 job_id = 2 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: optional google.protobuf.Struct payload = 3;
   */
  payload?: StructJson;
};

/**
 * Describes the message raccoonai.JobEventIn.
 * Use `create(JobEventInSchema)` to create a new message.
 */
export const JobEventInSchema: GenMessage<JobEventIn, {jsonType: JobEventInJson}> = /*@__PURE__*/
  messageDesc(file_job, 0);

/**
 * @generated from message raccoonai.Job
 */
export type Job = Message<"raccoonai.Job"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 2 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: required uint64 service_receiver_id = 4 [json_name = "service_receiver_id"];
   */
  serviceReceiverId: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 5 [json_name = "tw_start_at"];
   */
  twStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 6 [json_name = "tw_end_at"];
   */
  twEndAt?: Timestamp;

  /**
   * @generated from field: optional uint64 step_idx = 7 [json_name = "step_idx"];
   */
  stepIdx: bigint;

  /**
   * @generated from field: required uint64 author_id = 8 [json_name = "author_id"];
   */
  authorId: bigint;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 9 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * @generated from field: required uint64 pickup_location_id = 10 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: optional string service_started_report_url = 11 [json_name = "service_started_report_url"];
   */
  serviceStartedReportUrl: string;

  /**
   * @generated from field: optional string service_ended_report_url = 12 [json_name = "service_ended_report_url"];
   */
  serviceEndedReportUrl: string;

  /**
   * @generated from field: optional uint64 route_id = 13 [json_name = "route_id"];
   */
  routeId: bigint;

  /**
   * @generated from field: optional string driver_comment = 14 [json_name = "driver_comment"];
   */
  driverComment: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_start_at = 16 [json_name = "plan_start_at"];
   */
  planStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_end_at = 17 [json_name = "plan_end_at"];
   */
  planEndAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_start_at = 18 [json_name = "fact_start_at"];
   */
  factStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_end_at = 19 [json_name = "fact_end_at"];
   */
  factEndAt?: Timestamp;

  /**
   * @generated from field: required raccoonai.JobStatus status = 20;
   */
  status: JobStatus;

  /**
   * @generated from field: optional raccoonai.Organization service_receiver = 21 [json_name = "service_receiver"];
   */
  serviceReceiver?: Organization;

  /**
   * @generated from field: optional raccoonai.PickupLocation pickup_location = 22 [json_name = "pickup_location"];
   */
  pickupLocation?: PickupLocation;

  /**
   * @generated from field: optional raccoonai.DriverOnShift driver_on_shift = 23 [json_name = "driver_on_shift"];
   */
  driverOnShift?: DriverOnShift;

  /**
   * @generated from field: required raccoonai.JobType type = 24;
   */
  type: JobType;

  /**
   * @generated from field: required raccoonai.DispatcherReviewStatus dispatcher_review_status = 25 [json_name = "dispatcher_review_status"];
   */
  dispatcherReviewStatus: DispatcherReviewStatus;

  /**
   * To be deprecated in favor of file_reports with type SERVICE_START_PHOTO
   *
   * @generated from field: optional double service_start_photo_lat = 26 [json_name = "service_start_photo_lat"];
   */
  serviceStartPhotoLat: number;

  /**
   * To be deprecated in favor of file_reports with type SERVICE_START_PHOTO
   *
   * @generated from field: optional double service_start_photo_lon = 27 [json_name = "service_start_photo_lon"];
   */
  serviceStartPhotoLon: number;

  /**
   * To be deprecated in favor of file_reports with type SERVICE_END_PHOTO
   *
   * @generated from field: optional double service_end_photo_lat = 28 [json_name = "service_end_photo_lat"];
   */
  serviceEndPhotoLat: number;

  /**
   * To be deprecated in favor of file_reports with type SERVICE_END_PHOTO
   *
   * @generated from field: optional double service_end_photo_lon = 29 [json_name = "service_end_photo_lon"];
   */
  serviceEndPhotoLon: number;

  /**
   * To be deprecated in favor of container_group.container_type.name
   *
   * @generated from field: optional string container_name = 30 [json_name = "container_name"];
   */
  containerName: string;

  /**
   * @generated from field: optional uint64 job_tariff = 31 [json_name = "job_tariff"];
   */
  jobTariff: bigint;

  /**
   * @generated from field: optional bool is_pseudo = 32 [json_name = "is_pseudo"];
   */
  isPseudo: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_start_at = 33 [json_name = "gps_start_at"];
   */
  gpsStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_end_at = 34 [json_name = "gps_end_at"];
   */
  gpsEndAt?: Timestamp;

  /**
   * @generated from field: optional bool is_created_by_client = 35 [json_name = "is_created_by_client"];
   */
  isCreatedByClient: boolean;

  /**
   * @generated from field: optional uint64 scale_record_id = 36 [json_name = "scale_record_id"];
   */
  scaleRecordId: bigint;

  /**
   * @generated from field: optional raccoonai.User author = 37;
   */
  author?: User;

  /**
   * @generated from field: repeated raccoonai.FileUpload file_reports = 38 [json_name = "file_reports"];
   */
  fileReports: FileUpload[];

  /**
   * @generated from field: optional bool visible_to_ai = 39 [json_name = "visible_to_ai"];
   */
  visibleToAi: boolean;

  /**
   * @generated from field: required raccoonai.JobCategory job_category = 40 [json_name = "job_category"];
   */
  jobCategory: JobCategory;

  /**
   * To be deprecated in favor of container_group.container_type
   *
   * @generated from field: optional uint64 container_type_id = 41 [json_name = "container_type_id"];
   */
  containerTypeId: bigint;

  /**
   * To be deprecated in favor of container_group.container_type
   *
   * @generated from field: optional raccoonai.ContainerType container_type = 42 [json_name = "container_type"];
   */
  containerType?: ContainerType;

  /**
   * @generated from field: optional string order_number = 43 [json_name = "order_number"];
   */
  orderNumber: string;

  /**
   * @generated from field: optional bool receiver_notified = 44 [json_name = "receiver_notified"];
   */
  receiverNotified: boolean;

  /**
   * @generated from field: optional raccoonai.ContainerGroup container_group = 45 [json_name = "container_group"];
   */
  containerGroup?: ContainerGroup;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 46 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional raccoonai.UserRef updated_by = 55 [json_name = "updated_by"];
   */
  updatedBy?: UserRef;

  /**
   * @generated from field: optional raccoonai.Organization service_provider = 47 [json_name = "service_provider"];
   */
  serviceProvider?: Organization;

  /**
   * @generated from field: optional uint64 pickup_location_group_id = 48 [json_name = "pickup_location_group_id"];
   */
  pickupLocationGroupId: bigint;

  /**
   * AI verification verdicts for this job. Only populated by the endpoints that
   * ask for it (the government dashboard's job list and job detail); absent
   * elsewhere, and absent when no check has run for the job.
   *
   * @generated from field: optional raccoonai.AiVerification ai_verification = 49 [json_name = "ai_verification"];
   */
  aiVerification?: AiVerification;

  /**
   * @generated from field: optional uint64 whatsapp_author_id = 50 [json_name = "whatsapp_author_id"];
   */
  whatsappAuthorId: bigint;

  /**
   * Declared consignment-note facts, written only by ConsignmentNoteService.
   *
   * @generated from field: optional double num_of_container = 51 [json_name = "num_of_container"];
   */
  numOfContainer: number;

  /**
   * @generated from field: optional double weight_kg = 52 [json_name = "weight_kg"];
   */
  weightKg: number;

  /**
   * How full each serviced container was (0, 0.5, 0.75, 1.0 or 1.25 of its volume),
   * one entry per container, in the order they were sent.
   *
   * @generated from field: repeated double container_coefficients = 53 [json_name = "container_coefficients"];
   */
  containerCoefficients: number[];

  /**
   * m³ actually taken: Σcoefficient × container volume, or the dispatcher's override.
   *
   * @generated from field: optional double fact_total_volume = 54 [json_name = "fact_total_volume"];
   */
  factTotalVolume: number;

  /**
   * Containers the job covers (the dispatcher's «Кол-во контейнеров»); unset on older jobs.
   *
   * @generated from field: optional uint32 number_of_containers = 56 [json_name = "number_of_containers"];
   */
  numberOfContainers: number;

  /**
   * the contract the job was created under
   *
   * @generated from field: optional uint64 contract_id = 57 [json_name = "contract_id"];
   */
  contractId: bigint;

  /**
   * the schedule that generated it, if any
   *
   * @generated from field: optional uint64 schedule_id = 58 [json_name = "schedule_id"];
   */
  scheduleId: bigint;

  /**
   * @generated from field: optional raccoonai.Contract contract = 59;
   */
  contract?: Contract;
};

/**
 * @generated from message raccoonai.Job
 */
export type JobJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 2 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: required uint64 service_receiver_id = 4 [json_name = "service_receiver_id"];
   */
  service_receiver_id?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 5 [json_name = "tw_start_at"];
   */
  tw_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 6 [json_name = "tw_end_at"];
   */
  tw_end_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 step_idx = 7 [json_name = "step_idx"];
   */
  step_idx?: string;

  /**
   * @generated from field: required uint64 author_id = 8 [json_name = "author_id"];
   */
  author_id?: string;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 9 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * @generated from field: required uint64 pickup_location_id = 10 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: optional string service_started_report_url = 11 [json_name = "service_started_report_url"];
   */
  service_started_report_url?: string;

  /**
   * @generated from field: optional string service_ended_report_url = 12 [json_name = "service_ended_report_url"];
   */
  service_ended_report_url?: string;

  /**
   * @generated from field: optional uint64 route_id = 13 [json_name = "route_id"];
   */
  route_id?: string;

  /**
   * @generated from field: optional string driver_comment = 14 [json_name = "driver_comment"];
   */
  driver_comment?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_start_at = 16 [json_name = "plan_start_at"];
   */
  plan_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_end_at = 17 [json_name = "plan_end_at"];
   */
  plan_end_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_start_at = 18 [json_name = "fact_start_at"];
   */
  fact_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_end_at = 19 [json_name = "fact_end_at"];
   */
  fact_end_at?: TimestampJson;

  /**
   * @generated from field: required raccoonai.JobStatus status = 20;
   */
  status?: JobStatusJson;

  /**
   * @generated from field: optional raccoonai.Organization service_receiver = 21 [json_name = "service_receiver"];
   */
  service_receiver?: OrganizationJson;

  /**
   * @generated from field: optional raccoonai.PickupLocation pickup_location = 22 [json_name = "pickup_location"];
   */
  pickup_location?: PickupLocationJson;

  /**
   * @generated from field: optional raccoonai.DriverOnShift driver_on_shift = 23 [json_name = "driver_on_shift"];
   */
  driver_on_shift?: DriverOnShiftJson;

  /**
   * @generated from field: required raccoonai.JobType type = 24;
   */
  type?: JobTypeJson;

  /**
   * @generated from field: required raccoonai.DispatcherReviewStatus dispatcher_review_status = 25 [json_name = "dispatcher_review_status"];
   */
  dispatcher_review_status?: DispatcherReviewStatusJson;

  /**
   * To be deprecated in favor of file_reports with type SERVICE_START_PHOTO
   *
   * @generated from field: optional double service_start_photo_lat = 26 [json_name = "service_start_photo_lat"];
   */
  service_start_photo_lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * To be deprecated in favor of file_reports with type SERVICE_START_PHOTO
   *
   * @generated from field: optional double service_start_photo_lon = 27 [json_name = "service_start_photo_lon"];
   */
  service_start_photo_lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * To be deprecated in favor of file_reports with type SERVICE_END_PHOTO
   *
   * @generated from field: optional double service_end_photo_lat = 28 [json_name = "service_end_photo_lat"];
   */
  service_end_photo_lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * To be deprecated in favor of file_reports with type SERVICE_END_PHOTO
   *
   * @generated from field: optional double service_end_photo_lon = 29 [json_name = "service_end_photo_lon"];
   */
  service_end_photo_lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * To be deprecated in favor of container_group.container_type.name
   *
   * @generated from field: optional string container_name = 30 [json_name = "container_name"];
   */
  container_name?: string;

  /**
   * @generated from field: optional uint64 job_tariff = 31 [json_name = "job_tariff"];
   */
  job_tariff?: string;

  /**
   * @generated from field: optional bool is_pseudo = 32 [json_name = "is_pseudo"];
   */
  is_pseudo?: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_start_at = 33 [json_name = "gps_start_at"];
   */
  gps_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_end_at = 34 [json_name = "gps_end_at"];
   */
  gps_end_at?: TimestampJson;

  /**
   * @generated from field: optional bool is_created_by_client = 35 [json_name = "is_created_by_client"];
   */
  is_created_by_client?: boolean;

  /**
   * @generated from field: optional uint64 scale_record_id = 36 [json_name = "scale_record_id"];
   */
  scale_record_id?: string;

  /**
   * @generated from field: optional raccoonai.User author = 37;
   */
  author?: UserJson;

  /**
   * @generated from field: repeated raccoonai.FileUpload file_reports = 38 [json_name = "file_reports"];
   */
  file_reports?: FileUploadJson[];

  /**
   * @generated from field: optional bool visible_to_ai = 39 [json_name = "visible_to_ai"];
   */
  visible_to_ai?: boolean;

  /**
   * @generated from field: required raccoonai.JobCategory job_category = 40 [json_name = "job_category"];
   */
  job_category?: JobCategoryJson;

  /**
   * To be deprecated in favor of container_group.container_type
   *
   * @generated from field: optional uint64 container_type_id = 41 [json_name = "container_type_id"];
   */
  container_type_id?: string;

  /**
   * To be deprecated in favor of container_group.container_type
   *
   * @generated from field: optional raccoonai.ContainerType container_type = 42 [json_name = "container_type"];
   */
  container_type?: ContainerTypeJson;

  /**
   * @generated from field: optional string order_number = 43 [json_name = "order_number"];
   */
  order_number?: string;

  /**
   * @generated from field: optional bool receiver_notified = 44 [json_name = "receiver_notified"];
   */
  receiver_notified?: boolean;

  /**
   * @generated from field: optional raccoonai.ContainerGroup container_group = 45 [json_name = "container_group"];
   */
  container_group?: ContainerGroupJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 46 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;

  /**
   * @generated from field: optional raccoonai.UserRef updated_by = 55 [json_name = "updated_by"];
   */
  updated_by?: UserRefJson;

  /**
   * @generated from field: optional raccoonai.Organization service_provider = 47 [json_name = "service_provider"];
   */
  service_provider?: OrganizationJson;

  /**
   * @generated from field: optional uint64 pickup_location_group_id = 48 [json_name = "pickup_location_group_id"];
   */
  pickup_location_group_id?: string;

  /**
   * AI verification verdicts for this job. Only populated by the endpoints that
   * ask for it (the government dashboard's job list and job detail); absent
   * elsewhere, and absent when no check has run for the job.
   *
   * @generated from field: optional raccoonai.AiVerification ai_verification = 49 [json_name = "ai_verification"];
   */
  ai_verification?: AiVerificationJson;

  /**
   * @generated from field: optional uint64 whatsapp_author_id = 50 [json_name = "whatsapp_author_id"];
   */
  whatsapp_author_id?: string;

  /**
   * Declared consignment-note facts, written only by ConsignmentNoteService.
   *
   * @generated from field: optional double num_of_container = 51 [json_name = "num_of_container"];
   */
  num_of_container?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double weight_kg = 52 [json_name = "weight_kg"];
   */
  weight_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * How full each serviced container was (0, 0.5, 0.75, 1.0 or 1.25 of its volume),
   * one entry per container, in the order they were sent.
   *
   * @generated from field: repeated double container_coefficients = 53 [json_name = "container_coefficients"];
   */
  container_coefficients?: (number | "NaN" | "Infinity" | "-Infinity")[];

  /**
   * m³ actually taken: Σcoefficient × container volume, or the dispatcher's override.
   *
   * @generated from field: optional double fact_total_volume = 54 [json_name = "fact_total_volume"];
   */
  fact_total_volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Containers the job covers (the dispatcher's «Кол-во контейнеров»); unset on older jobs.
   *
   * @generated from field: optional uint32 number_of_containers = 56 [json_name = "number_of_containers"];
   */
  number_of_containers?: number;

  /**
   * the contract the job was created under
   *
   * @generated from field: optional uint64 contract_id = 57 [json_name = "contract_id"];
   */
  contract_id?: string;

  /**
   * the schedule that generated it, if any
   *
   * @generated from field: optional uint64 schedule_id = 58 [json_name = "schedule_id"];
   */
  schedule_id?: string;

  /**
   * @generated from field: optional raccoonai.Contract contract = 59;
   */
  contract?: ContractJson;
};

/**
 * Describes the message raccoonai.Job.
 * Use `create(JobSchema)` to create a new message.
 */
export const JobSchema: GenMessage<Job, {jsonType: JobJson}> = /*@__PURE__*/
  messageDesc(file_job, 1);

/**
 * @generated from message raccoonai.JobCreate
 */
export type JobCreate = Message<"raccoonai.JobCreate"> & {
  /**
   * To be switched to required in the future
   *
   * @generated from field: optional uint64 service_provider_id = 1 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * To be switched to required in the future
   *
   * @generated from field: optional uint64 service_receiver_id = 2 [json_name = "service_receiver_id"];
   */
  serviceReceiverId: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 3 [json_name = "tw_start_at"];
   */
  twStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 4 [json_name = "tw_end_at"];
   */
  twEndAt?: Timestamp;

  /**
   * @generated from field: optional uint64 step_idx = 5 [json_name = "step_idx"];
   */
  stepIdx: bigint;

  /**
   * @generated from field: optional uint64 author_id = 6 [json_name = "author_id"];
   */
  authorId: bigint;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 7 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * To be switched to optional in the future
   *
   * @generated from field: required uint64 pickup_location_id = 8 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * To be deprecated
   *
   * @generated from field: optional string service_started_report_url = 9 [json_name = "service_started_report_url"];
   */
  serviceStartedReportUrl: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional string service_ended_report_url = 10 [json_name = "service_ended_report_url"];
   */
  serviceEndedReportUrl: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 route_id = 11 [json_name = "route_id"];
   */
  routeId: bigint;

  /**
   * @generated from field: optional string driver_comment = 12 [json_name = "driver_comment"];
   */
  driverComment: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_start_at = 13 [json_name = "plan_start_at"];
   */
  planStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_end_at = 14 [json_name = "plan_end_at"];
   */
  planEndAt?: Timestamp;

  /**
   * @generated from field: required raccoonai.JobType type = 15;
   */
  type: JobType;

  /**
   * @generated from field: optional uint64 job_tariff = 16 [json_name = "job_tariff"];
   */
  jobTariff: bigint;

  /**
   * @generated from field: optional bool is_pseudo = 17 [json_name = "is_pseudo"];
   */
  isPseudo: boolean;

  /**
   * @generated from field: optional bool visible_to_ai = 18 [json_name = "visible_to_ai"];
   */
  visibleToAi: boolean;

  /**
   * @generated from field: required raccoonai.JobCategory job_category = 19 [json_name = "job_category"];
   */
  jobCategory: JobCategory;

  /**
   * We don't need this
   *
   * @generated from field: optional uint64 container_type_id = 20 [json_name = "container_type_id"];
   */
  containerTypeId: bigint;

  /**
   * To be switched to required in the future
   *
   * @generated from field: optional uint64 container_group_id = 21 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;

  /**
   * @generated from field: optional uint64 pickup_location_group_id = 22 [json_name = "pickup_location_group_id"];
   */
  pickupLocationGroupId: bigint;

  /**
   * Containers the job covers (the dispatcher's «Кол-во контейнеров»).
   *
   * @generated from field: optional uint32 number_of_containers = 23 [json_name = "number_of_containers"];
   */
  numberOfContainers: number;
};

/**
 * @generated from message raccoonai.JobCreate
 */
export type JobCreateJson = {
  /**
   * To be switched to required in the future
   *
   * @generated from field: optional uint64 service_provider_id = 1 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * To be switched to required in the future
   *
   * @generated from field: optional uint64 service_receiver_id = 2 [json_name = "service_receiver_id"];
   */
  service_receiver_id?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 3 [json_name = "tw_start_at"];
   */
  tw_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 4 [json_name = "tw_end_at"];
   */
  tw_end_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 step_idx = 5 [json_name = "step_idx"];
   */
  step_idx?: string;

  /**
   * @generated from field: optional uint64 author_id = 6 [json_name = "author_id"];
   */
  author_id?: string;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 7 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * To be switched to optional in the future
   *
   * @generated from field: required uint64 pickup_location_id = 8 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional string service_started_report_url = 9 [json_name = "service_started_report_url"];
   */
  service_started_report_url?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional string service_ended_report_url = 10 [json_name = "service_ended_report_url"];
   */
  service_ended_report_url?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 route_id = 11 [json_name = "route_id"];
   */
  route_id?: string;

  /**
   * @generated from field: optional string driver_comment = 12 [json_name = "driver_comment"];
   */
  driver_comment?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_start_at = 13 [json_name = "plan_start_at"];
   */
  plan_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_end_at = 14 [json_name = "plan_end_at"];
   */
  plan_end_at?: TimestampJson;

  /**
   * @generated from field: required raccoonai.JobType type = 15;
   */
  type?: JobTypeJson;

  /**
   * @generated from field: optional uint64 job_tariff = 16 [json_name = "job_tariff"];
   */
  job_tariff?: string;

  /**
   * @generated from field: optional bool is_pseudo = 17 [json_name = "is_pseudo"];
   */
  is_pseudo?: boolean;

  /**
   * @generated from field: optional bool visible_to_ai = 18 [json_name = "visible_to_ai"];
   */
  visible_to_ai?: boolean;

  /**
   * @generated from field: required raccoonai.JobCategory job_category = 19 [json_name = "job_category"];
   */
  job_category?: JobCategoryJson;

  /**
   * We don't need this
   *
   * @generated from field: optional uint64 container_type_id = 20 [json_name = "container_type_id"];
   */
  container_type_id?: string;

  /**
   * To be switched to required in the future
   *
   * @generated from field: optional uint64 container_group_id = 21 [json_name = "container_group_id"];
   */
  container_group_id?: string;

  /**
   * @generated from field: optional uint64 pickup_location_group_id = 22 [json_name = "pickup_location_group_id"];
   */
  pickup_location_group_id?: string;

  /**
   * Containers the job covers (the dispatcher's «Кол-во контейнеров»).
   *
   * @generated from field: optional uint32 number_of_containers = 23 [json_name = "number_of_containers"];
   */
  number_of_containers?: number;
};

/**
 * Describes the message raccoonai.JobCreate.
 * Use `create(JobCreateSchema)` to create a new message.
 */
export const JobCreateSchema: GenMessage<JobCreate, {jsonType: JobCreateJson}> = /*@__PURE__*/
  messageDesc(file_job, 2);

/**
 * @generated from message raccoonai.JobUpdate
 */
export type JobUpdate = Message<"raccoonai.JobUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * To be switched to required in the future
   *
   * @generated from field: optional uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * To be switched to required in the future
   *
   * @generated from field: optional uint64 service_receiver_id = 3 [json_name = "service_receiver_id"];
   */
  serviceReceiverId: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 4 [json_name = "tw_start_at"];
   */
  twStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 5 [json_name = "tw_end_at"];
   */
  twEndAt?: Timestamp;

  /**
   * @generated from field: optional uint64 step_idx = 6 [json_name = "step_idx"];
   */
  stepIdx: bigint;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 7 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 pickup_location_id = 8 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * To be deprecated
   *
   * @generated from field: optional string service_started_report_url = 9 [json_name = "service_started_report_url"];
   */
  serviceStartedReportUrl: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional string service_ended_report_url = 10 [json_name = "service_ended_report_url"];
   */
  serviceEndedReportUrl: string;

  /**
   * @generated from field: optional uint64 route_id = 11 [json_name = "route_id"];
   */
  routeId: bigint;

  /**
   * @generated from field: optional string driver_comment = 12 [json_name = "driver_comment"];
   */
  driverComment: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_start_at = 13 [json_name = "plan_start_at"];
   */
  planStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_end_at = 14 [json_name = "plan_end_at"];
   */
  planEndAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_start_at = 15 [json_name = "fact_start_at"];
   */
  factStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_end_at = 16 [json_name = "fact_end_at"];
   */
  factEndAt?: Timestamp;

  /**
   * @generated from field: optional raccoonai.JobStatus status = 17;
   */
  status: JobStatus;

  /**
   * @generated from field: optional raccoonai.JobType type = 18;
   */
  type: JobType;

  /**
   * @generated from field: optional raccoonai.DispatcherReviewStatus dispatcher_review_status = 19 [json_name = "dispatcher_review_status"];
   */
  dispatcherReviewStatus: DispatcherReviewStatus;

  /**
   * To be deprecated
   *
   * @generated from field: optional double service_start_photo_lat = 20 [json_name = "service_start_photo_lat"];
   */
  serviceStartPhotoLat: number;

  /**
   * To be deprecated
   *
   * @generated from field: optional double service_start_photo_lon = 21 [json_name = "service_start_photo_lon"];
   */
  serviceStartPhotoLon: number;

  /**
   * To be deprecated
   *
   * @generated from field: optional double service_end_photo_lat = 22 [json_name = "service_end_photo_lat"];
   */
  serviceEndPhotoLat: number;

  /**
   * To be deprecated
   *
   * @generated from field: optional double service_end_photo_lon = 23 [json_name = "service_end_photo_lon"];
   */
  serviceEndPhotoLon: number;

  /**
   * To be deprecated
   *
   * @generated from field: optional string container_name = 24 [json_name = "container_name"];
   */
  containerName: string;

  /**
   * @generated from field: optional uint64 job_tariff = 25 [json_name = "job_tariff"];
   */
  jobTariff: bigint;

  /**
   * @generated from field: optional bool is_pseudo = 26 [json_name = "is_pseudo"];
   */
  isPseudo: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_start_at = 28 [json_name = "gps_start_at"];
   */
  gpsStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_end_at = 29 [json_name = "gps_end_at"];
   */
  gpsEndAt?: Timestamp;

  /**
   * @generated from field: optional bool visible_to_ai = 30 [json_name = "visible_to_ai"];
   */
  visibleToAi: boolean;

  /**
   * @generated from field: optional raccoonai.JobCategory job_category = 31 [json_name = "job_category"];
   */
  jobCategory: JobCategory;

  /**
   * @generated from field: optional uint64 container_type_id = 32 [json_name = "container_type_id"];
   */
  containerTypeId: bigint;

  /**
   * @generated from field: optional bool receiver_notified = 33 [json_name = "receiver_notified"];
   */
  receiverNotified: boolean;

  /**
   * @generated from field: optional uint64 container_group_id = 34 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;

  /**
   * Containers the job covers.
   *
   * @generated from field: optional uint32 number_of_containers = 35 [json_name = "number_of_containers"];
   */
  numberOfContainers: number;
};

/**
 * @generated from message raccoonai.JobUpdate
 */
export type JobUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * To be switched to required in the future
   *
   * @generated from field: optional uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * To be switched to required in the future
   *
   * @generated from field: optional uint64 service_receiver_id = 3 [json_name = "service_receiver_id"];
   */
  service_receiver_id?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 4 [json_name = "tw_start_at"];
   */
  tw_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 5 [json_name = "tw_end_at"];
   */
  tw_end_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 step_idx = 6 [json_name = "step_idx"];
   */
  step_idx?: string;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 7 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 pickup_location_id = 8 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional string service_started_report_url = 9 [json_name = "service_started_report_url"];
   */
  service_started_report_url?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional string service_ended_report_url = 10 [json_name = "service_ended_report_url"];
   */
  service_ended_report_url?: string;

  /**
   * @generated from field: optional uint64 route_id = 11 [json_name = "route_id"];
   */
  route_id?: string;

  /**
   * @generated from field: optional string driver_comment = 12 [json_name = "driver_comment"];
   */
  driver_comment?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_start_at = 13 [json_name = "plan_start_at"];
   */
  plan_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_end_at = 14 [json_name = "plan_end_at"];
   */
  plan_end_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_start_at = 15 [json_name = "fact_start_at"];
   */
  fact_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_end_at = 16 [json_name = "fact_end_at"];
   */
  fact_end_at?: TimestampJson;

  /**
   * @generated from field: optional raccoonai.JobStatus status = 17;
   */
  status?: JobStatusJson;

  /**
   * @generated from field: optional raccoonai.JobType type = 18;
   */
  type?: JobTypeJson;

  /**
   * @generated from field: optional raccoonai.DispatcherReviewStatus dispatcher_review_status = 19 [json_name = "dispatcher_review_status"];
   */
  dispatcher_review_status?: DispatcherReviewStatusJson;

  /**
   * To be deprecated
   *
   * @generated from field: optional double service_start_photo_lat = 20 [json_name = "service_start_photo_lat"];
   */
  service_start_photo_lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * To be deprecated
   *
   * @generated from field: optional double service_start_photo_lon = 21 [json_name = "service_start_photo_lon"];
   */
  service_start_photo_lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * To be deprecated
   *
   * @generated from field: optional double service_end_photo_lat = 22 [json_name = "service_end_photo_lat"];
   */
  service_end_photo_lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * To be deprecated
   *
   * @generated from field: optional double service_end_photo_lon = 23 [json_name = "service_end_photo_lon"];
   */
  service_end_photo_lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * To be deprecated
   *
   * @generated from field: optional string container_name = 24 [json_name = "container_name"];
   */
  container_name?: string;

  /**
   * @generated from field: optional uint64 job_tariff = 25 [json_name = "job_tariff"];
   */
  job_tariff?: string;

  /**
   * @generated from field: optional bool is_pseudo = 26 [json_name = "is_pseudo"];
   */
  is_pseudo?: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_start_at = 28 [json_name = "gps_start_at"];
   */
  gps_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_end_at = 29 [json_name = "gps_end_at"];
   */
  gps_end_at?: TimestampJson;

  /**
   * @generated from field: optional bool visible_to_ai = 30 [json_name = "visible_to_ai"];
   */
  visible_to_ai?: boolean;

  /**
   * @generated from field: optional raccoonai.JobCategory job_category = 31 [json_name = "job_category"];
   */
  job_category?: JobCategoryJson;

  /**
   * @generated from field: optional uint64 container_type_id = 32 [json_name = "container_type_id"];
   */
  container_type_id?: string;

  /**
   * @generated from field: optional bool receiver_notified = 33 [json_name = "receiver_notified"];
   */
  receiver_notified?: boolean;

  /**
   * @generated from field: optional uint64 container_group_id = 34 [json_name = "container_group_id"];
   */
  container_group_id?: string;

  /**
   * Containers the job covers.
   *
   * @generated from field: optional uint32 number_of_containers = 35 [json_name = "number_of_containers"];
   */
  number_of_containers?: number;
};

/**
 * Describes the message raccoonai.JobUpdate.
 * Use `create(JobUpdateSchema)` to create a new message.
 */
export const JobUpdateSchema: GenMessage<JobUpdate, {jsonType: JobUpdateJson}> = /*@__PURE__*/
  messageDesc(file_job, 3);

/**
 * @generated from message raccoonai.JobList
 */
export type JobList = Message<"raccoonai.JobList"> & {
  /**
   * @generated from field: repeated raccoonai.Job jobs = 1;
   */
  jobs: Job[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.JobList
 */
export type JobListJson = {
  /**
   * @generated from field: repeated raccoonai.Job jobs = 1;
   */
  jobs?: JobJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.JobList.
 * Use `create(JobListSchema)` to create a new message.
 */
export const JobListSchema: GenMessage<JobList, {jsonType: JobListJson}> = /*@__PURE__*/
  messageDesc(file_job, 4);

/**
 * @generated from message raccoonai.JobFileUploadRequest
 */
export type JobFileUploadRequest = Message<"raccoonai.JobFileUploadRequest"> & {
  /**
   * @generated from field: required raccoonai.File file = 1;
   */
  file?: File;

  /**
   * @generated from field: required raccoonai.FileUploadType type = 2;
   */
  type: FileUploadType;

  /**
   * @generated from field: optional uint64 job_id = 3 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: optional string container_name = 4 [json_name = "container_name"];
   */
  containerName: string;

  /**
   * @generated from field: repeated double container_coefficients = 5 [json_name = "container_coefficients"];
   */
  containerCoefficients: number[];
};

/**
 * @generated from message raccoonai.JobFileUploadRequest
 */
export type JobFileUploadRequestJson = {
  /**
   * @generated from field: required raccoonai.File file = 1;
   */
  file?: FileJson;

  /**
   * @generated from field: required raccoonai.FileUploadType type = 2;
   */
  type?: FileUploadTypeJson;

  /**
   * @generated from field: optional uint64 job_id = 3 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: optional string container_name = 4 [json_name = "container_name"];
   */
  container_name?: string;

  /**
   * @generated from field: repeated double container_coefficients = 5 [json_name = "container_coefficients"];
   */
  container_coefficients?: (number | "NaN" | "Infinity" | "-Infinity")[];
};

/**
 * Describes the message raccoonai.JobFileUploadRequest.
 * Use `create(JobFileUploadRequestSchema)` to create a new message.
 */
export const JobFileUploadRequestSchema: GenMessage<JobFileUploadRequest, {jsonType: JobFileUploadRequestJson}> = /*@__PURE__*/
  messageDesc(file_job, 5);

/**
 * A job to plan: an existing one, or the one a container group gets for a job
 * type on a day. Exactly one of container_group_id + job_type, or job_id.
 *
 * @generated from message raccoonai.JobStop
 */
export type JobStop = Message<"raccoonai.JobStop"> & {
  /**
   * @generated from field: optional uint64 container_group_id = 1 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;

  /**
   * @generated from field: optional raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  jobType: JobType;

  /**
   * @generated from field: optional uint64 job_id = 3 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * Container group stop: tw_start_at picks the schedule window that day
   * (unset: the first one); none matching, or no window that day, means the
   * whole day. Schedules never reject a stop. Ignored on job_id stops.
   *
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 4 [json_name = "tw_start_at"];
   */
  twStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 5 [json_name = "tw_end_at"];
   */
  twEndAt?: Timestamp;

  /**
   * Output only (preview): the existing job this stop resolves to. Ignored in
   * requests.
   *
   * @generated from field: optional raccoonai.Job job = 6;
   */
  job?: Job;
};

/**
 * A job to plan: an existing one, or the one a container group gets for a job
 * type on a day. Exactly one of container_group_id + job_type, or job_id.
 *
 * @generated from message raccoonai.JobStop
 */
export type JobStopJson = {
  /**
   * @generated from field: optional uint64 container_group_id = 1 [json_name = "container_group_id"];
   */
  container_group_id?: string;

  /**
   * @generated from field: optional raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;

  /**
   * @generated from field: optional uint64 job_id = 3 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * Container group stop: tw_start_at picks the schedule window that day
   * (unset: the first one); none matching, or no window that day, means the
   * whole day. Schedules never reject a stop. Ignored on job_id stops.
   *
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 4 [json_name = "tw_start_at"];
   */
  tw_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 5 [json_name = "tw_end_at"];
   */
  tw_end_at?: TimestampJson;

  /**
   * Output only (preview): the existing job this stop resolves to. Ignored in
   * requests.
   *
   * @generated from field: optional raccoonai.Job job = 6;
   */
  job?: JobJson;
};

/**
 * Describes the message raccoonai.JobStop.
 * Use `create(JobStopSchema)` to create a new message.
 */
export const JobStopSchema: GenMessage<JobStop, {jsonType: JobStopJson}> = /*@__PURE__*/
  messageDesc(file_job, 6);

